/* eslint-disable max-len */
import React from 'react';

import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  PortalOverlay,
  PortalOverlayHeader,
  PortalOverlayModal,
  HeaderText,
  BodyText,
  Stack,
  Absolute,
  Button,
  Touchable,
} from '../../ui';
import { ArrowsChevronLeftIcon } from '../../ui/Icons';
import { useIsMobile } from '../../../hooks';

type ShareMenuDetailsModalProps = {
  onBackPress: (trackingEvent: string) => void;
};

export const ShareMenuDetailsModal: React.FC<ShareMenuDetailsModalProps> = ({
  onBackPress,
}) => {
  const isMobile = useIsMobile();

  return (
    <PortalOverlay name="share-modal">
      <PortalOverlayModal
        position="fullScreen"
        color={colors.redLite}
        borderRadius={isMobile ? undefined : 20}
      >
        <PortalOverlayHeader
          renderLeftAction={() => (
            <Touchable
              testID="client-share-details-backarrow"
              onClick={() => onBackPress('client_share_details_backarrow_clicked')}
            >
              <Box padding={8}><ArrowsChevronLeftIcon /></Box>
            </Touchable>
          )}
          renderTitle={() => (
            <Box
              justifyContent="center"
            >
              <HeaderText level={2}>Details</HeaderText>
            </Box>
          )}
          style={{
            borderBottomColor: colors.blackInBlack,
            borderBottomWidth: 0.5,
          }}
        />
        <Box padding={16} paddingTop={48} flex={1}>
          <Stack space={8} padding={16} paddingTop={48} alignItems="center">
            <HeaderText level={1}>Get 15% off appointments</HeaderText>
            <Box paddingTop={16} paddingBottom={24} paddingX={32} testID="share-menu-details-body-text-testid">
              <Box paddingY={8}><BodyText textAlign="left">Receive 15% off (max discount $50) when you discover and book with an eligible new pro on StyleSeat.</BodyText></Box>
              <Box paddingY={8}><BodyText textAlign="left">Discount applied at checkout.</BodyText></Box>
              <Box paddingY={8}><BodyText textAlign="left">Must complete payment through StyleSeat.</BodyText></Box>
              <Box paddingY={8}><BodyText textAlign="left">Cannot be combined with other offers.</BodyText></Box>
              <Box paddingY={8}><BodyText textAlign="left">Must be scheduled through the web or app.</BodyText></Box>
            </Box>
          </Stack>

          <Absolute left={24} bottom={24} right={24}>
            <Button
              testID="client-share-details-cta"
              onClick={() => onBackPress('client_close_details_backarrow_clicked')}
              text="Got It"
              appearance="primary-neue"
            />
          </Absolute>
        </Box>
      </PortalOverlayModal>
    </PortalOverlay>
  );
};

export default ShareMenuDetailsModal;
